<template>
  <div class="card-list-item product-item">
    <div class="helper-button" v-on:click="showModal" v-if="!auto"></div>
    <div class="card-item-main-wrap" v-if="!auto">
      <div class="card-item-main">
        <div class="card-item-image" :style="{ backgroundImage: 'url('+productImage+')'}" v-if="product.file_id"></div>
        <div :class="'card-item-title product-item-title' + (product.file_id ? ' has-image' : ' no-image')" v-on:click="showPreviewModal">
          <div class="card-item-name-wrap"><span class="card-item-name product-item-name" v-if="displayName === 'both' || !displayName">{{ $filters.posname(product) }}</span><span class="card-item-name product-item-name" v-if="displayName === 'product'">{{ product.name }}</span><span class="card-item-name product-item-name" v-if="displayName === 'marketing'">{{ $filters.marketingname(product) }}</span><span class="cart-item-warehousecount product-item-warehousecount" v-if="false && parseInt(product.allow_sale_under_warehouse) == 0 && !isEvent"> ({{ parseInt(product.allow_sale_under_warehouse) ?  '' : product.warehouse_count }})</span></div>
          <span v-if="product && hasVisiblePricing" class="card-item-price product-item-price"><span v-if="parseInt(product.multiple_prices)">{{ _('From') }} </span>{{ $filters.currency(product.price, product.currency) }}</span>
        </div>
      </div>
      <a class="view-button btn btn-default" v-on:click="showPreviewModal"><span class="fa fa-fw fa-info"></span></a>
    </div>
    <div class="product-item-footer card-item-footer" v-if="!auto">
      <div class="input-group product-item-button card-item-button" v-if="isTicketCountSelectorVisible">
        <multiselect v-model.number="participants[0]" :options="participantValues" :multiple="false" :show-labels="false" :searchable="false" :allow-empty="false" @update:modelValue="participantsChanged"></multiselect>
        <span class="input-group-btn">
          <button class="btn btn-info" v-on:click="addNextTicketActivityToBasket()"><span class="text-large">{{ _('Add') }}</span><span class="text-small"><span class="fa fa-fw fa-shopping-basket"></span></span></button>
        </span>
      </div>
      <div class="product-item-button card-item-button reservable-item-button" v-else>
        <button class="btn btn-info" @click="showModal">{{ _('Add') }}</button>
      </div>
    </div>
    <modal :name="previewModalId" :adaptive="true" :width="1000" :maxWidth="1000" :maxHeight="500" :scrollable="true" height="auto">
      <product-popup :product="product" :shopId="productShopId" :productShopId="productShopId" :baseDomain="baseDomain" :locale="locale" v-on:close="hidePreviewModal"></product-popup>
    </modal>
    <modal :name="modalId" :adaptive="true" :width="1000" :maxWidth="1000" :maxHeight="500" :scrollable="true" height="auto" v-on:before-close="productModalClosed">
      <span class="close-modal" @click="closeModal"></span>
      <div class="product-header">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3>{{ $filters.posname(product) }}</h3>
            </div>
          </div>
        </div>
      </div>
      <editor-tabs id="tabNavi" v-if="summary" :tabs="[{ id: 'new', label: _('New reservation') }, { id: 'summary', label: _('Summary') }]" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="product-order-wrap" style="min-height: 600px" v-if="isFeatureEnabled('widgetv3')">
        <johku-widget :id="productShopId + '/Product'" :locale="locale" :version="version" :item-id="product.id" :data="widgetData"></johku-widget>
      </div>
      <div class="summary-wrap" v-if="isTabActive('summary')">
        <div class="summary">
          <h4>{{ _('Summary of related orders') }}</h4>
          <template v-if="orders && orders.length">
            <div v-for="order in orders" class="order-wrapper">
              <div class="order-row">
                <div class="order-name">{{ order.id }}: {{ order.name ? order.name : _('Johku App') }}</div>
                <div class="order-email">{{ order.email }}</div>
                <div class="order-phone">{{ order.phone }}</div>
                <div class="order-total">{{ $filters.currency(order.totalWithDelivery, currency) }}</div>
              </div>
              <div v-for="item in order.ownItem.filter(i => i.product_id == product.id)" class="item-row">
                <div class="item-range">{{ item.reservation_desc }}</div>
                <div class="item-participants">{{ _('Participants') }}: {{ item.reservation_count }}</div>
              </div>
            </div>
          </template>
          <div v-else>{{ _('No orders found.') }}</div>
        </div>
      </div>
      <seat-map :column="column" :show="activeShow" :showButtons="true" :ticketShopId="productShopId" :seatMap="seatMap" v-if="showSeatMap" v-on:confirmSelection="seatSelectionConfirmed" v-on:closeModal="closeSeatMap" v-on:seatSelected="seatSelected" v-on:seatDeselected="seatDeselected"></seat-map>
    </modal>
  </div>  
</template>

<script>
import axios from 'axios'
// import DatePicker from '~/components/DatePicker.vue'
// import SeatMap from '~/components/SeatMap.vue'
// import ProductPopup from '~/components/ProductPopup.vue'
import constants from '~/lib/constants'
import errors from '~/lib/errors'
import seatmap from '~/lib/seatmap'
import settingshelpers from '~/lib/settingshelpers'
import tabs from '~/lib/tabs'
import Multiselect from 'vue-multiselect'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
// import ResourceList from './ResourceList.vue'

export default {
  data () {
    return {
      numberOfSeats: [],
      productCount: '1',
      resourceCount: '1',
      selectedRoute: false,
      selectedOrigin: false,
      selectedDestination: false,
      triptype: 'M',
      currentPricing: 'hours',
      dailyStartDate: null,
      startDate: null,
      endDate: null,
      minDate: null,
      maxDate: null,
      returnDate: null,
      startTime: null,
      endTime: null,
      returnTime: null,
      returnEndTime: null,
      defaultParticipants: [],
      fullprices: {},
      availabletimes: {},
      availablereturntimes: {},
      detailedPricingVisible: false,
      lastStart: false,
      showGroupDealDateSelector: false,
      showGroupDealDays: false,
      showSeatMap: false,
      seatMap: null,
      selectedSeats: [],
      seatTicketId: null,
      activeShow: false,
      groupDealDateSelected: false,
      groupDealDays: [],
      popoverTimeout: null,
      upsellProductCache: null,
      previousProduct: false,
      stopCache: null,
      lightbox: null,
      slider: null,
      defaultSelectedResources: [],
      groupDealInfoVisible: false,
      availablePreselectedDates: [],
      availablePreselectedDatesLoading: [],
      shows: [],
      showAvailability: [],
      gettingShows: false,
      selectedTicket: false,
      resourceSeats: {},
      automaticResourceSelection: true,
      activeTab: 'new',
      orders: [],
      hasStartTimesToday: false,
      useExtraCapacity: false,
      resourcepoolAvailability: [],
      selectedResourcepools: [],
      closeModalTimeout: null
    }
  },
  mixins: [constants, errors, seatmap, settingshelpers, tabs],
  props: ['product', 'productShopId', 'column', 'activeComponent', 'baseDomain', 'auto', 'summary', 'summaryStart', 'summaryEnd', 'defaultStartDate', 'defaultEndDate', 'allowResourceSelection', 'preselectedResource', 'mode', 'displayName'],
  components: {
    Multiselect,
  },
  watch: {
    customPrice (val) {
      if (!val || !this.product) {
        return
      }
      let maxPrice = parseFloat(this.product.maxprice, 10)
      if (val.replace) {
        val = val.replace(',', '.')
        this.product.price = val
      }
      if (parseFloat(val) > maxPrice) {
        this.product.price = maxPrice
      }
    },
    reservationCount () {
      this.updateAvailablePreselectedDates()
    },
    resourceCount () {
      this.updateAvailablePreselectedDates()
    },
    selectedPricing () {
      this.updateAvailablePreselectedDates()
    }
  },
  mounted () {
    if (this.auto) {
      this.showModal()
    }
    if (this.summary) {
      this.loadOrderSummary()
    }
    this.EventBus.$on('setBasketItems', this.addedToBasketHandler)
    if (this.isFeatureEnabled('widgetv3')) {
      return
    }
    if (this.mode && this.mode === 'daily' && this.hasDailyPricing) { // Fix: Only set daily pricing if it's actually available!
      this.setDailyPricing()
    } else {
      this.setHourlyPricing()
    }
    this.initParticipants()
    this.participantsChanged()
    if (this.defaultStartDate) {
      if (this.selectedPricing === 'days') {
        this.startDateChanged(this.defaultStartDate)
        if (this.defaultEndDate) {
          this.endDateChanged(this.defaultEndDate)
        }
      } else {
        this.hourlyDateChanged(this.defaultStartDate, this.mode !== 'daily') // Don't try to set time if we're doing hourly pricing from a daily view, since the start time will be 0.00
      }
    }
    if (this.product && this.product.sharedResourcepool) {
      for (let i = 0; i < this.product.sharedResourcepool.length; i++) {
        let rp = this.product.sharedResourcepool[i]
        this.resourceSeats[rp.id] = {}
        if (rp.sharedResource) {
          for (let j = 0; j < rp.sharedResource.length; j++) {
            let r = rp.sharedResource[j]
            this.resourceSeats[rp.id][r.id] = null
            if (this.isResourceSelectionAllowed && this.preselectedResource === r.id) {
              this.resourceSeats[rp.id][r.id] = 1
            }
          }
        }
      }
    }
    if (this.isResourceSelectionAllowed && this.preselectedResource) {
      this.automaticResourceSelection = false
    }
  },
  beforeUnmount () {
    this.EventBus.$off('setBasketItems', this.addedToBasketHandler)
  },
  computed: {
    ...mapGetters(['activeBasket', 'activeOrder', 'clientid', 'apiKey', 'pos', 'posDeliveryActive', 'locale', 'version', 'shopId', 'selfService', 'dateFormat', 'timeFormat', 'timezone']),
    widgetData () {
      return JSON.stringify({
        basketId: this.basketId,
        orderIdentifier: this.activeOrder ? this.activeOrder.identifier : null,
        clientId: this.clientid,
        masterShopId: this.shopId,
        index: this.activeBasket,
        pos: this.pos,
        posDeliveryActive: this.posDeliveryActive,
        apiKey: this.apiKey,
        hideProductName: true,
        css: this.widgetCss,
        defaultStartDate: this.defaultStartDate,
        defaultEndDate: this.defaultEndDate,
        defaultStartTime: this.defaultStartTime(),
        defaultEndTime: this.defaultEndTime(this.defaultStartDate),
        preferredResource: this.preselectedResource
      })
    },
    widgetCss () {
      return `
        #johku-widget .product-order-wrap { 
          background-color: transparent;
        }
        #johku-widget .input-group .form-control {
          padding-top: 9px;
          padding-bottom: 10px;
        }
        #johku-widget .product-order-price {
          color: #679F38;
        }
        :host { 
          --widget-text-color: #111;
          --widget-primary-color: #2571bd;
          --widget-success-color: #679F38;
          --widget-error-color: #e53935;
          --widget-dark-color: #111;
          --widget-bg-color: transparent; 
          --widget-border-radius: 0px; 
          --widget-button-border-radius: 0px; 
          --widget-input-border-radius: 0px;
          --widget-font-family: "Oxygen", sans-serif;
          --widget-titlebar-bg-color: rgb(103, 159, 56);
        }`
    },
    hasResourcepoolHierarchy () {
      return this.product && this.product.sharedResourcepool && this.product.sharedResourcepool.length && this.product.sharedResourcepool.some(pool => pool.sharedResourcepool && pool.sharedResourcepool.length)
    },
    resourcepoolsWithHierarchy () {
      if (!this.hasResourcepoolHierarchy) {
        return []
      }
      return this.product.sharedResourcepool.filter(pool => pool.sharedResourcepool && pool.sharedResourcepool.length)
    },
    hasMultipleDailyStartTimes () {
      return this.product && this.product.ownStarttime && this.product.ownStarttime.filter && this.product.ownStarttime.filter(t => t.mode === 'daily').length > 1
    },
    totalParticipantCount() {
      if (parseInt(this.product.enable_participant_pricing)) {
        return this.reservationCount
      } else {
        return 10000
      }
    },
    currentDate () {
      if (!this.startDate) {
        return null
      }
      if (!this.startTime) {
        return this.startDate
      }
      const tArr = this.startTime.split('.')
      return DateTime.fromJSDate(this.startDate, { zone: this.timezone }).set({ hour: parseInt(tArr[0], 10), minute: parseInt(tArr[1], 10) }).toJSDate()
    },
    isResourceSelectionAllowed () {
      if (this.overrideAllowResourceSelection) {
        return true
      }
      return this.allowResourceSelection
    },
    clientStr () {
      if (this.clientid && this.shopId === this.productShopId) {
        return '&client=' + this.clientid
      }
      return ''
    },
    hasPreselectedValues () {
      return this.preselectedValues.length
    },
    preselectedValues () {
      const minPrice = parseFloat(this.product.minprice, 10) 
      const maxPrice = parseFloat(this.product.maxprice, 10) 
      const minDiff = 10
      if (!maxPrice) return []
      if (minPrice + (minDiff * 2) >= maxPrice) {
        return [minPrice, maxPrice]
      }
      return [minPrice, Math.round(maxPrice/2), maxPrice]
    },
    customPrice: {
      get () {
        return this.product ? this.product.price : 0
      },
      set (newValue) {
        this.product.price = newValue
      }
    },
    valueRange () {
      let minPrice = parseFloat(this.product.minprice,10) || 0
      let maxPrice = parseFloat(this.product.maxprice,10)

      if (!maxPrice) {
        return this.$filters.currency(minPrice, this.product.currency) + ' – '
      }
      return this.$filters.currency(minPrice, this.product.currency) + ' – ' + this.$filters.currency(maxPrice, this.product.currency) 
    },
    activePricingIndex() {
      let activeIndex = 0
      if (
        this.fullprices &&
        this.fullprices.selectedlength &&
        this.fullprices.selectedunittype
      ) {
        for (let i = 0; i < this.fullprices.prices.detail.length; i++) {
          if (
            parseInt(this.fullprices.prices.detail[i].unit, 10) ===
              parseInt(this.fullprices.selectedlength, 10) &&
            parseInt(this.fullprices.prices.detail[i].unittype, 10) ===
              parseInt(this.fullprices.selectedunittype, 10)
          ) {
            activeIndex = i
          }
        }
      }
      return activeIndex
    },
    isTicketCountSelectorVisible () {
      if (parseInt(this.product.hide_pricing) === 5 && ((parseInt(this.product.enable_participant_pricing) && !this.product.sharedPricetier.length) || (!parseInt(this.product.enable_participant_pricing) && this.quantity == 1 && this.maxParticipants > 1 && !this.product.sharedPricetier.length))) {
        return true
      }
      return false
    },
    participantValues () {
      let returnValues = []
      for (let i = 0; i < this.maxParticipants; i++) {
        returnValues.push(i + 1)
      }
      return returnValues;
    },
    modalId () {
      return (this.column ? this.column.identifier : 'virtual') + '-component-' + this.activeComponent.id + '-product-' + this.product.id + '-' + this.productShopId
    },
    previewModalId () {
      return (this.column ? this.column.identifier : 'virtual') + '-component-' + this.activeComponent.id + '-product-' + this.product.id + '-preview'
    },
    settings () {
      return this.$store.state.settings[this.productShopId + '-' + this.locale]
    },
    basketId () {
      return this.$store.state.basketIds[this.productShopId + '-' + this.$store.state.activeBasket]
    },
    isSoldOut () {
      if (!this.product) {
        return false
      }
      if (!parseInt(this.product.allow_sale_under_warehouse) && this.maxProducts < 1) {
        return true
      }
      return false
    },
    isReturnTrip () {
      if (this.triptype === 'MP') {
        return true
      }
      return false
    },
    actionText () {
      if (this.product && this.product.buttontext) {
        return this.product.buttontext
      }
      return !this.isForcedOpenOrder ? (this.isReservable ? this._('Reserve') : this._('Buy')) : this._('Request a quote')
    },
    upsellTitle () {
      return this.settings.upselltitle || this._('Also recommended')
    },
    productImage () {
      return (this.product.file_id ? this.baseDomain + this.productShopId + '/files/' + this.product.file_id + '.' +this.product.file_ext : 'data:image/gif;base64,R0lGODlhDwAKAJEAAAAAAP///////wAAACH5BAEHAAIALAAAAAAPAAoAAAIKlI+py+0Po5xUFgA7')
    },
    titleBelowImage () {
      return parseInt(this.masterSettings.pagetitlelocation) > 0
    },
    shopTitle () {
      return this.masterSettings.shoptitle || this.masterSettings.companyname
    },
    stops () {
      if (this.stopCache) {
        return this.stopCache
      }
      let stops = []
      if (this.product && this.product.sharedResource && this.product.sharedResource.length) {
        for (var i = 0; i < this.product.sharedResource.length; i++) {
          let resource = this.product.sharedResource[i]
          if (resource.sharedRoute) {
            for (var j = 0; j < resource.sharedRoute.length; j++) {
              let route = resource.sharedRoute[j]
              if (route.sharedStop) {
                for (var k = 0; k < route.sharedStop.length; k++) {
                  let stop = route.sharedStop[k]
                  stop.route = route.id
                  stop.type = route.type
                  stops.push(stop)
                }
              }
            }
          }
        }
      }
      this.stopCache = stops
      return stops
    },
    goStops () {
      let stops = this.stops
      let unique = []
      let ids = []
      for (var i = 0; i < stops.length; i++) {
        if (!ids[stops[i].id]) {
          ids[stops[i].id] = true
          unique.push(stops[i])
        }
      }
      return unique.filter(function (s) {
        return s.type === 'M'
      }).sort(function (a, b) {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },
    returnStops () {
      let stops = this.stops
      let unique = []
      let ids = []
      for (var i = 0; i < stops.length; i++) {
        if (!ids[stops[i].id]) {
          ids[stops[i].id] = true
          unique.push(stops[i])
        }
      }
      return unique.filter(function (s) {
        return s.type === 'P'
      }).sort(function (a, b) {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },
    destinationStops () {
      if (!this.selectedRoute) {
        return this.stops
      }
      let stops = []
      let offset = 0
      if (this.selectedOrigin) {
        offset = this.selectedOrigin.offset ? parseInt(this.selectedOrigin.offset, 10) : 0
      }
      for (var i = 0; i < this.stops.length; i++) {
        if (this.stops[i].route === this.selectedRoute && this.stops[i].offset !== offset) {
          stops.push(this.stops[i])
        }
      }
      let unique = []
      let ids = []
      for (i = 0; i < stops.length; i++) {
        if (!ids[stops[i].id]) {
          ids[stops[i].id] = true
          unique.push(stops[i])
        }
      }
      return unique.sort(function (a, b) {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
    },
    /*
    arrivalTime () {
      let startOffset = 0
      let destOffset = 0
      if (this.selectedOrigin && this.selectedDestination) {
        startOffset = parseInt(this.selectedOrigin.offset, 10)
        destOffset = parseInt(this.selectedDestination.offset, 10)
        return this.convertToTime(this.convertToMinutes(this.startTime) + (destOffset - startOffset))
      }
      return ''
    },
    returnArrivalTime () {
      let startOffset = 0
      let destOffset = 0
      if (this.selectedOrigin && this.selectedDestination) {
        startOffset = parseInt(this.selectedOrigin.offset, 10)
        destOffset = parseInt(this.selectedDestination.offset, 10)
        return this.convertToTime(this.convertToMinutes(this.startTime) + (destOffset - startOffset))
      }
      return ''
    },
    */
    isTransportation () {
      if (this.product && parseInt(this.product.subtype) === this.SUBTYPE_TRANSPORTATION) {
        return true
      }
      return false
    },
    isAvailableForSale () {
      if (!this.product || parseInt(this.product.hide_pricing) === 2) {
        return false
      }
      return true
    },
    isForcedOpenOrder () {
      if (parseInt(this.product.hide_pricing) === 1 || parseInt(this.product.hide_pricing) === 3) {
        return true
      }
      return false
    },
    hasVisiblePricing () {
      if (!this.product || parseInt(this.product.hide_pricing) === 1 || this.isEvent) {
        return false
      }
      return true
    },
    hasSelectableResources () {
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return false
      }
      if (parseInt(this.selfService)) {
        return false
      }
      if (this.isResourceSelectionAllowed) {
        return true
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (parseInt(this.product.sharedResourcepool[i].selectable)) {
          return true
        }
      }
      return false
    },
    selectableResourcePools () {
      let pools = []
      if (!this.product || !this.product.sharedResourcepool || !this.product.sharedResourcepool.length) {
        return pools
      }
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if ((parseInt(this.product.sharedResourcepool[i].selectable) || this.isResourceSelectionAllowed) && this.product.sharedResourcepool[i].sharedResource && this.product.sharedResourcepool[i].sharedResource.length > 0) {
          pools.push(this.product.sharedResourcepool[i])
        }
      }
      return pools
    },
   preselectedDates () {
      let ret = []
      if (!this.product.preselecteddates) {
        return ret
      }
      let cutoff = new Date()
      if (!this.selectedPricing === 'days' || !!parseInt(this.product.deadlineoffset, 10)) {
        let offset = parseInt(this.product.deadlineoffset, 10) * 3600 * 1000
        cutoff = new Date(cutoff.getTime() + offset)
      } else {
        cutoff.setDate(cutoff.getDate() - 1) // Default cutoff = yesterday
      }
      let pDates = this.product.preselecteddates.split(';')
      for (let i = 0; i < pDates.length; i++) {
        if (pDates[i]) {
          let ts = this.convertDateToTimestamp(pDates[i])
          let today = new Date()
          today.setHours(0,0,0,0)
          if (ts > cutoff.getTime() || (today.getTime() === ts && this.hasStartTimesToday)) {
            ret.push(pDates[i])
          }
        }
      }
      if (ret.length === 1 && !this.startDate) {
        if (this.selectedPricing === 'days') {
          this.preselectedDateChanged(new Date(this.convertDateToTimestamp(ret[0])))
        } else {
          this.hourlyDateChanged(new Date(this.convertDateToTimestamp(ret[0])))
        }
      }
      return ret
    },
    upsellProducts () {
      let $this = this
      if (this.upsellProductCache && this.upsellProductCache[this.product.id]) {
        return this.upsellProductCache[this.product.id]
      }
      if (!this.product || !this.product.ownLinkedproduct || !this.product.ownLinkedproduct.length) {
        this.upsellProductCache = []
        return this.upsellProductCache
      }
      let urlArray = []
      let doneIds = []
      for (var i = 0; i < this.product.ownLinkedproduct.length; i++) {
        if (parseInt(this.product.ownLinkedproduct[i].type, 10) === 1 && doneIds.indexOf(this.product.ownLinkedproduct[i].linkedproduct_id) === -1) {
          urlArray.push(axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.ownLinkedproduct[i].linkedproduct_id + '.json?version=' + this.locale))
          doneIds.push(this.product.ownLinkedproduct[i].linkedproduct_id)
        }
      }
      axios.all(urlArray)
      .then(axios.spread(function () {
        let ret = []
        for (var i = 0; i < arguments.length; i++) {
          let p = arguments[i].data
          if (p) {
            ret.push({
              id: p.id,
              source_id: p.id,
              name: parseInt(p.usemarketingname) && p.marketingname ? p.marketingname : p.name,
              type: p.type,
              shopid: $this.productShopId,
              product: p
            })
          }
        }
        $this.upsellProductCache = []
        $this.upsellProductCache[$this.product.id] = ret
        return ret
      }))
      .catch(function () {
        $this.upsellProductCache = []
        return $this.upsellProductCache
      })
    },
    hasUpsellProducts () {
      if (!this.product || !this.product.ownLinkedproduct || !this.product.ownLinkedproduct.length) {
        return false
      }
      for (var i = 0; i < this.product.ownLinkedproduct.length; i++) {
        if (parseInt(this.product.ownLinkedproduct[i].type, 10) === 1) {
          return true
        }
      }
      return false
    },
    hasDetailedPricing () {
      if (this.fullprices && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.detail.length > 0) {
        return true
      }
      return false
    },
    hasMultiplePrices () {
      return parseInt(this.product.multiple_prices)
    },
    hasMultipleDetailedPrices () {
      if (this.fullprices && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.detail.length > 1) {
        return true
      }
      return false
    },
    hasCoordinates () {
      return this.product && this.product.channeldata && parseFloat(this.product.channeldata.latitude) && parseFloat(this.product.channeldata.longitude)
    },
    priceIncludesMultiplePersons () {
      if (this.product && this.product.ownPricerow && this.product.ownPricerow[0] && parseInt(this.product.ownPricerow[0].includes, 10) > 1) {
        return true
      }
      return false
    },
    priceIncludesDescription () {
      let includeStr = ''
      if (this.fullprices && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.detail.length) {
        if (parseInt(this.fullprices.prices.detail[0].includes, 10) === 1) {
          includeStr = this._('Price includes %s person.')
        } else if (parseInt(this.fullprices.prices.detail[0].includes, 10) > 1) {
          includeStr = this._('Price includes %s persons.')
        }
        includeStr = includeStr.replace(/%s/, this.fullprices.prices.detail[0].includes)
      }
      return includeStr
    },
    datesSelected () {
      if (this.selectedPricing === 'days') {
        return this.startDate && this.endDate
      }
      return this.startDate
    },
    currentPrice () {
      let s = ''
      if (parseInt(this.product.multiple_prices)) {
        if (!this.datesSelected) {
          s += this._('From') + ' '
        }
      }
      let field = 'baseprice'
      if (this.isReturnTrip) {
        field = 'returnprice'
      }
      let curr = this.$filters.currency
      if (this.datesSelected && this.fullprices && this.fullprices.finalprice) {
        if (parseInt(this.fullprices.finalprice, 10) === -1) {
          s += this._('We were unable to find a valid pricing for the selected dates. Please try a different date range.')
        } else {
          if (this.selectedTicket) {
            s += this.$filters.currency(this.reservationCount * this.selectedTicketPrice, this.product.currency)
          } else {
            s += this.$filters.currency(this.fullprices.finalpricetotal, this.product.currency)
          }
        }
        return s
      }
      if (this.datesSelected && this.fullprices && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.baseprice) {
        let data = this.fullprices
        if (data.prices[field] === 0 && data.prices.detail && data.prices.detail[0] && data.prices.detail[0].pricetiers) {
          let firstTierPrice = 0
          for (var ptId in data.prices.detail[0].pricetiers) {
            if (Object.prototype.hasOwnProperty.call(data.prices.detail[0].pricetiers.hasOwnProperty, ptId)) {
              firstTierPrice = data.prices.detail[0].pricetiers[ptId]
              break
            }
          }
          s += curr(firstTierPrice, this.product.currency) + (this.isTransportation || parseInt(this.product.hide_units) ? '' : ' / ' + (parseInt(data.prices.unit, 10) > 1 ? data.prices.unit + ' ' : '') + this.getUnitStr(data.prices.unittype))
        } else if (data.prices[field] && data.prices.detail && data.prices.detail.length) {
          let participants = this.reservationCount
          let found = false
          for (var i = 0; i < data.prices.detail.length; i++) {
            let d = data.prices.detail[i]
            if (!d.minparticipants || d.minparticipants <= participants) {
              if (!d.maxparticipants || d.maxparticipants >= participants) {
                s += curr(d[field], this.product.currency) + (this.isTransportation || parseInt(this.product.hide_units) ? '' : ' / ' + (parseInt(d.unit, 10) > 1 ? d.unit + ' ' : '') + this.getUnitStr(d.unittype))
                // s += curr(d[field], this.product.currency)
                found = true
                break
              }
            }
          }
          if (!found && data.prices[field]) {
            s += curr(data.prices[field], this.product.currency) + (this.isTransportation || parseInt(this.product.hide_units) ? '' : ' / ' + (parseInt(data.prices.unit, 10) > 1 ? data.prices.unit + ' ' : '') + this.getUnitStr(data.prices.unittype))
            // s += curr(data.prices[field], this.product.currency)
          }
        } else if (data.prices[field]) {
          s += curr(data.prices[field], this.product.currency) + (this.isTransportation || parseInt(this.product.hide_units) ? '' : ' / ' + (parseInt(data.prices.unit, 10) > 1 ? data.prices.unit + ' ' : '') + this.getUnitStr(data.prices.unittype))
          // s += curr(data.prices[field], this.product.currency)
        }
      } else {
        s += this.$filters.currency(this.product.price, this.product.currency)
      }
      return s
    },
    selectedTicketPrice () {
      if (!this.selectedTicket) {
        return 0
      }
      if (!this.fullprices || !this.fullprices.prices || !this.fullprices.prices.detail || !this.fullprices.prices.detail[this.activePricingIndex] || !this.fullprices.prices.detail[this.activePricingIndex].tickets) {
        return 0
      }
      for (var i = 0; i < this.fullprices.prices.detail[this.activePricingIndex].tickets.length; i++) {
        if (parseInt(this.fullprices.prices.detail[this.activePricingIndex].tickets[i].id, 10) === parseInt(this.selectedTicket, 10)) {
          return this.fullprices.prices.detail[this.activePricingIndex].tickets[i].price
        }
      }
      return 0
    },
    selectedTicketPricing () {
      if (!this.selectedTicket) {
        return 0
      }
      if (!this.fullprices || !this.fullprices.prices || !this.fullprices.prices.detail || !this.fullprices.prices.detail[this.activePricingIndex] || !this.fullprices.prices.detail[this.activePricingIndex].tickets) {
        return 0
      }
      for (var i = 0; i < this.fullprices.prices.detail[this.activePricingIndex].tickets.length; i++) {
        if (parseInt(this.fullprices.prices.detail[this.activePricingIndex].tickets[i].id, 10) === parseInt(this.selectedTicket, 10)) {
          return this.fullprices.prices.detail[this.activePricingIndex].pricing
        }
      }
      return 0
    },
    currentUnitStr () {
      let unitStr = ''
      if (parseInt(this.product.hide_units)) {
        return unitStr
      }
      if (this.datesSelected && this.fullprices && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.baseprice) {
        return unitStr
      }
      if (this.datesSelected && this.fullprices && parseInt(this.fullprices.finalprice, 10)) {
        return unitStr
      }
      unitStr = ' / '
      let unitExt = ''
      /*
      // this does not fucking work because we only have one "prices from" price, and that is for the shortest unit
      let unitArr = this.product.product_units.split(';')
      let units = 1
      let unitType = this.product.product_unit
      for (var i = 0; i < unitArr.length; i++) {
        if (this.selectedPricing === 'days' && unitArr[i].match(/d$/)) {
          units = parseInt(unitArr[i], 10)
          unitType = 3
          break
        } else if (this.selectedPricing === 'hours' && unitArr[i].match(/h$/)) {
          units = parseInt(unitArr[i], 10)
          unitType = 2
          break
        } else if (this.selectedPricing === 'hours' && unitArr[i].match(/m$/)) {
          units = parseInt(unitArr[i], 10)
          unitType = 1
          break
        }
      }
      if (units > 1) {
        unitExt += parseInt(units) + ' '
      }
      unitExt += this.getUnitStr(unitType)
      */
      if (parseInt(this.product.product_unit) > 1) {
        unitExt += parseInt(this.product.product_unit) + ' '
      }
      unitExt += this.getUnitStr(this.product.unit_type)
      unitStr += this.convertToHoursAndMinutes(unitExt)
      return unitStr
    },
    reservationCount () {
      return this.participants.reduce(function (a, b) { return parseInt(a, 10) + parseInt(b, 10) }, 0)
    },
    carouselLength () {
      return (parseInt(this.product.file_id) ? 1 : 0)
    },
    isGroupDeal () {
      if (parseInt(this.product.min_count) > 1) {
        return true
      }
      return false
    },
    isEvent () {
      return parseInt(this.product.subtype) === this.SUBTYPE_EVENT
    },
    isTicketActivity () {
      return parseInt(this.product.hide_pricing) === 5
    },
    isReservable () {
      return parseInt(this.product.type) !== 0 && !this.isEvent
    },
    isBuyable () {
      return parseInt(this.product.type) === 0 && !this.isEvent
    },
    hasParticipantPricing () {
      return parseInt(this.product.enable_participant_pricing, 10) > 0
    },
    extrasCostSomething () {
      if (!this.product.ownPricerow || !this.product.ownPricerow.length) {
        return false
      }
      if (!this.product.sharedPricetier || !this.product.sharedPricetier.length) {
        return false
      }
      for (var i = 0; i < this.product.ownPricerow.length; i++) {
        let tiers = this.product.ownPricerow[i].pricetiers.split(';')
        for (var j = 0; j < tiers.length; j++) {
          let tierPrice = tiers[j].split(':')
          if (parseFloat(tierPrice[1])) {
            return true
          }
        }
      }
      return false
    },
    hasPricetiers () {
      return this.product.sharedPricetier.length > 0
    },
    priceIncludesParticipants () {
      if (this.product.ownPricerow && this.product.ownPricerow[0] && parseInt(this.product.ownPricerow[0].includes, 10) > 0) {
        return true
      }
      return false
    },
    isMultiMode () {
      return this.hasHourlyPricing && this.hasDailyPricing
    },
    hasHourlyPricing () {
      return this.product.product_units ? this.product.product_units.match(/h/) || this.product.product_units.match(/m/) : false
    },
    hasDailyPricing () {
      return this.product.product_units ? this.product.product_units.match(/d/) : false
    },
    selectedPricing: {
      get () {
        if (this.isMultiMode) {
          return this.currentPricing
        } else if (this.hasDailyPricing) {
          return 'days'
        }
        return 'hours'
      },
      set (val) {
        this.currentPricing = val
      }
    },
    participants: {
      get () {
        if (this.product && this.defaultParticipants.length) {
          return this.defaultParticipants
        } else if (this.product) {
          this.defaultParticipants = [this.defaultParticipantCount]
          if (this.product.sharedPricetier) {
            for (var i = 1; i < this.product.sharedPricetier.length; i++) {
              this.defaultParticipants.push(0)
            }
          }
          return this.defaultParticipants
        }
        return []
      },
      set (val) {
        this.defaultParticipants = val
      }
    },
    selectedResources: {
      get () {
        if (this.product && this.defaultSelectedResources.length) {
          return this.defaultSelectedResources
        } else if (this.product) {
          this.defaultSelectedResources = []
          for (var i = 0; i < this.selectableResourcePools.length; i++) {
            this.defaultSelectedResources[this.selectableResourcePools[i].id] = this.selectableResourcePools[i].sharedResource[0].id
          }
          return this.defaultSelectedResources
        }
        return []
      },
      set (val) {
        this.defaultSelectedResources = val
      }
    },
    countLimits() {
      let quantity = false
      let minCount = 0
      let maxCount = 0 // Let's not enforce the limit of 100
      let maxBasketResources = 0
      let hasSelectableResourcePools = false
      if (this.product.sharedResource) {
        for (var i = 0; i < this.product.sharedResource.length; i++) {
          if (this.product.sharedResource[i].displayedtype === 'openinghours') {
            continue
          }
          if (parseInt(this.product.sharedResource[i].mincount, 10)) {
            minCount = Math.max(minCount, parseInt(this.product.sharedResource[i].mincount, 10))
          }
          if (this.product.sharedResource[i].ownSeat && this.product.sharedResource[i].ownSeat.length) {
            if (!maxCount) {
              maxCount = this.product.sharedResource[i].ownSeat.length
            } else {
              maxCount = Math.min(maxCount, this.product.sharedResource[i].ownSeat.length)
            }
          } else {
            if (!maxCount) {
              maxCount = parseInt(this.product.sharedResource[i].count, 10)
            } else {
              maxCount = Math.min(maxCount, parseInt(this.product.sharedResource[i].count, 10))
            }
            if (this.useExtraCapacity) {
              maxCount += parseInt(this.product.sharedResource[i].extracount, 10)
            }
            if (!quantity) {
              quantity = parseInt(this.product.sharedResource[i].quantity, 10)
            } else {
              quantity = Math.min(quantity, parseInt(this.product.sharedResource[i].quantity, 10))
            }
          }
        }
      }

      if (this.product.sharedResourcepool) {
        for (i = 0; i < this.product.sharedResourcepool.length; i++) {
          var poolMinCount = false
          var poolMaxCount = false
          for (var j = 0; j < this.product.sharedResourcepool[i].sharedResource.length; j++) {
            if (parseInt(this.product.sharedResourcepool[i].sharedResource[j].mincount, 10)) {
              if (poolMinCount === false) {
                poolMinCount = parseInt(this.product.sharedResourcepool[i].sharedResource[j].mincount, 10)
              } else {
                poolMinCount = Math.min(poolMinCount, parseInt(this.product.sharedResourcepool[i].sharedResource[j].mincount, 10))
              }
            }
            if (this.product.sharedResourcepool[i].seatallocation === 'single') {
              if (this.product.sharedResourcepool[i].sharedResource[j].ownSeat && this.product.sharedResourcepool[i].sharedResource[j].ownSeat.length) {
                if (poolMaxCount === false) {
                  poolMaxCount = this.product.sharedResourcepool[i].sharedResource[j].ownSeat.length
                } else {
                  poolMaxCount = Math.max(poolMaxCount, this.product.sharedResourcepool[i].sharedResource[j].ownSeat.length)
                }
              } else if (parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10)) {
                if (poolMaxCount === false) {
                  poolMaxCount = parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10)
                } else {
                  poolMaxCount = Math.max(poolMaxCount, parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10))
                }
                if (this.useExtraCapacity) {
                  maxCount += parseInt(this.product.sharedResourcepool[i].sharedResource[j].extracount, 10)
                }
              }
            } else {
              if (this.product.sharedResourcepool[i].sharedResource[j].ownSeat && this.product.sharedResourcepool[i].sharedResource[j].ownSeat.length) {
                poolMaxCount += this.product.sharedResourcepool[i].sharedResource[j].ownSeat.length
              } else if (parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10)) {
                poolMaxCount += parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10)
                if (this.useExtraCapacity) {
                  maxCount += parseInt(this.product.sharedResourcepool[i].sharedResource[j].extracount, 10)
                }
              }
            }
          }
          if (poolMinCount !== false) {
            minCount = Math.max(minCount, poolMinCount)
          }
          if (poolMaxCount !== false) {
            if (!maxCount) {
              maxCount = poolMaxCount
            } else {
              maxCount = Math.min(maxCount, poolMaxCount)
            }
          }
          if (parseInt(this.product.sharedResourcepool[i].selectable)) {
            hasSelectableResourcePools = true
            if (quantity === false) {
              quantity = this.product.sharedResourcepool[i].sharedResource.length
            } else {
              quantity = Math.min(quantity, this.product.sharedResourcepool[i].sharedResource.length)
            }
            /*if (parseInt(this.product.maxallowedseats, 10)) {
              this.product.sharedResourcepool[i].sharedResource.sort((a,b) => parseInt(a.mincount, 10) - parseInt(b.mincount, 10))
              maxBasketResources = 0
              let seatCount = 0
              for(j = 0; j < this.product.sharedResourcepool[i].sharedResource.length; j++) {
                seatCount = seatCount + parseInt(this.product.sharedResourcepool[i].sharedResource[j].mincount, 10)
                if(seatCount > parseInt(this.product.maxallowedseats, 10)) {
                  continue
                }
                maxBasketResources++
              }
            }*/
          }
        }
      }
      let minParticipants = false
      if (this.product.ownPricerow) {
        for (i = 0; i < this.product.ownPricerow.length; i++) {
          let minp = parseInt(this.product.ownPricerow[i].minparticipants, 10)
          if (minParticipants === false) {
            if (minp > 0) {
              minParticipants = minp
            } else {
              minParticipants = 0
            }
          } else {
            minParticipants = Math.min(minParticipants, minp)
          }
        }
      }
      if (!quantity) {
        quantity = 1
      }
      if (!minCount) {
        minCount = 1
      }
      const resourceMinCount = minCount
      if (parseInt(this.product.relaxmincount, 10) === 1 && parseInt(this.product.subtype, 10) === this.SUBTYPE_ACTIVITY) {
        minCount = 1
      }
      if (minParticipants > 1) {
        minCount = Math.max(minParticipants, minCount)
      }
      if (!maxCount) {
        maxCount = 100 // just set this as the default max
      }
      // if (parseInt(this.product.maxallowedseats, 10)) { // If there is a limit on allowed seats on basket per product let's not do too much teasing
      //  maxCount = Math.min(parseInt(this.product.maxallowedseats, 10), maxCount)
      /* if(hasSelectableResourcePools) {
        quantity = Math.min(maxBasketResources, quantity)
      }*/
      //}
      maxCount = Math.max(minCount, maxCount)
      if (this.isOption && this.optionCapacity) {
        maxCount = Math.min(maxCount, this.optionCapacity)
      }
      return { quantity: quantity, minCount: minCount, maxCount: maxCount, resourceMinCount: resourceMinCount }
    },
    defaultParticipantCount () {
      if (parseInt(this.product.relaxmincount, 10) === 1 && parseInt(this.product.subtype, 10) === this.SUBTYPE_ACTIVITY) {
        return this.countLimits.resourceMinCount || this.minParticipants
      }
      return this.minParticipants
    },
    quantityTitle () {
      if ((parseInt(this.product.enable_participant_pricing) && !this.product.sharedPricetier.length) || (!parseInt(this.product.enable_participant_pricing) && this.quantity == 1 && this.maxParticipants > 1 && !this.product.sharedPricetier.length)) {
        return this.product.quantitytitle ? this.product.quantitytitle : this._('pers')
      } else {
        return this.product.quantitytitle ? this.product.quantitytitle : this._('Pcs')
      }
    },
    quantity () {
      return this.countLimits.quantity
    },
    minParticipants () {
      return this.countLimits.minCount
    },
    maxParticipants () {
      let maxCount = this.countLimits.maxCount
      if (!maxCount) {
        maxCount = 100
      }
      return maxCount
    },
    maxProducts () {
      let max = 50
      if (parseInt(this.product.allow_sale_under_warehouse)) {
        return max
      }
      if (this.selectedResources.length && this.selectableResourcePools.length) {
        for (var i = 0; i < this.selectableResourcePools.length; i++) {
          var poolId = this.selectableResourcePools[i].id
          var resourceId = parseInt(this.selectedResources[poolId], 10)
          for (var j = 0; j < this.selectableResourcePools[i].sharedResource.length; j++) {
            if (parseInt(this.selectableResourcePools[i].sharedResource[j].id, 10) === resourceId) {
              if (this.selectableResourcePools[i].sharedResource[j].warehouse_count !== null) {
                max = Math.min(max, this.selectableResourcePools[i].sharedResource[j].warehouse_count)
              }
              break
            }
          }
        }
      }
      return Math.min(max, parseInt(this.product.warehouse_count, 10))
    },
    shortLocale () {
      return this.locale.split('_')[0]
    }
  },
  methods: {
    addedToBasketHandler() {
      if (this.isFeatureEnabled('widgetv3')) {
        this.EventBus.$emit('showFloatingReceipt')
        this.closeModalTimeout && clearTimeout(this.closeModalTimeout)
        this.closeModalTimeout = setTimeout(() => {
          this.hideModal()
        }, 1000) // This timeout is important so that we ensure that the modal isn't closed before options have been triggered
      }
    },
    formatTime (time) {
      return DateTime.fromFormat(time, 'H.mm', { zone: this.timezone }).toFormat(this.timeFormat)
    },
    getResourceCount(resource) {
      let c =  0
      let base = parseInt(resource.count, 10) 
      let extra = parseInt(resource.extracount, 10) 
      if (base) {
        c += base
      }
      if (extra) {
        c += extra
      }
      return c
    },
    checkCustomPrice () {
      let val = this.customPrice
      let minPrice = parseFloat(this.product.minprice, 10)
      let maxPrice = parseFloat(this.product.maxprice, 10)
      if (val.replace) {
        val = val.replace(',', '.')
      }
      if (!val || parseFloat(val) < minPrice) {
        this.product.price = minPrice
      }
      if (parseFloat(val) > maxPrice) {
        this.product.price = maxPrice
      }
    },
    getActivePricingIndex(data) {
      let activeIndex = 0
      if (
        data &&
        data.selectedlength &&
        data.selectedunittype
      ) {
        for (let i = 0; i < data.prices.detail.length; i++) {
          if (
            parseInt(data.prices.detail[i].unit, 10) ===
              parseInt(data.selectedlength, 10) &&
            parseInt(data.prices.detail[i].unittype, 10) ===
              parseInt(data.selectedunittype, 10)
          ) {
            activeIndex = i
          }
        }
      }
      return activeIndex
    },
    getSelectedTicketPricing (pricingIndex, data) {
      if (!pricingIndex || !(data && data.prices && data.prices.detail)) {
        return 0
      }
      return data.prices.detail[pricingIndex].pricing
    },
    async showModal () {
      this.startDate = null
      this.endDate = null
      this.minDate = null
      this.maxDate = null
      this.returnDate = null
      this.startTime = null
      this.endTime = null
      this.returnTime = null
      this.returnEndTime = null
      this.fullprices = {}
      this.availabletimes = {}
      this.availablereturntimes = {}
      this.overrideAllowResourceSelection = true
      if (this.product.preselecteddates) {
        await this.updateAvailablePreselectedDates()
        await this.updateStartTimeAvailability()
      }
      await this.getNextShows()
      this.$modal.show(this.modalId)
    },
    hideModal () {
      this.$modal.hide(this.modalId)
    },
    closeModal () {
      // Clear + close
      if (!this.isFeatureEnabled('widgetv3')) {
        this.clear()
      }
      this.hideModal()
    },
    showPreviewModal () {
      this.$modal.show(this.previewModalId)
    },
    hidePreviewModal () {
      this.$modal.hide(this.previewModalId)
    },
    productModalClosed () {
      this.$emit('productModalClosed', this.modalId)
      this.$emit('close', this.modalId) // This is for calls with this.showModal
    },
    updateAvailablePreselectedDates (force) { // eslint-disable-line no-unused-vars
      return new Promise(async (resolve, reject) => {
        if (!this.product.preselecteddates) {
          resolve()
          return
        }
        let key = this.reservationCount + '-' + this.resourceCount + '-' + this.selectedPricing
        if (force || !this.availablePreselectedDatesLoading[key]) {
          this.availablePreselectedDatesLoading[key] = true
          let response = await axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.id + '/availablepreselecteddates.json?count=' + this.reservationCount + '&resource_count=' + this.resourceCount + '&mode=' + this.selectedPricing)
          this.availablePreselectedDates = response.data
          this.availablePreselectedDatesLoading[key] = false
        }
        resolve()
      })
    },
    clear () {
      this.defaultParticipants = [this.defaultParticipantCount]
      for (var i = 1; i < this.product.sharedPricetier.length; i++) {
        this.defaultParticipants.push(0)
      }
      if (this.resourceCount > 1) {
        this.resourceCount = 1
      }
      this.clearDates()
    },
    clearDates () {
      this.startDate = null
      this.endDate = null
      this.minDate = null
      this.maxDate = null
      this.startTime = null
      this.endTime = null
      this.returnDate = null
      this.returnTime = null
      this.groupDealDateSelected = false
      this.fullprices = {}
      this.selectedTicket = null
      this.resourcepoolAvailability = []
    },
    addDailyReservationToBasket () {
      let $this = this
      var i = 0
      if (!this.startDate) {
        return
      }
      if (!this.endDate && parseInt(this.product.allow_multiday)) {
        return
      }
      if (!parseInt(this.product.allow_multiday)) {
        this.endDate = new Date(this.startDate)
        let days = 1
        let unitArr = this.product.product_units.split(';')
        for (i = 0; i < unitArr.length; i++) {
          if (unitArr[i].match(/d$/)) {
            days = parseInt(unitArr[i], 10)
            break
          }
        }
        this.endDate.setDate(this.endDate.getDate() + days)
      }
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        shopId: this.productShopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: this.reservationCount,
        reservationDateStart: this.getDMY(this.startDate),
        reservationDateEnd: this.getDMY(this.endDate),
        reservationTimeStart: this.availabletimes && this.availabletimes.starttimes ? this.startTime : '12.00',
        reservationTimeEnd: this.availabletimes && this.availabletimes.starttimes ? this.endTime : '12.00'
      }
      // This should not happen for now, but let's add these just in case
      if (this.isTransportation) {
        data.origin = this.selectedOrigin.id
        data.destination = this.selectedDestination.id
      }
      if (this.isTicketActivity) {
        data.ticket = this.selectedTicket
        data.pricing = this.selectedTicketPricing
      }
      if (this.isResourceSelectionAllowed && this.hasSelectableResources) {
        let selectedReservationCount = 0
        for (i = 0; i < this.product.sharedResourcepool.length; i++) {
          let rp = this.product.sharedResourcepool[i]
          const selectableIds = this.getSelectableResources(rp).map(r => r.id)
          let seats = []
          for (let resourceId in this.resourceSeats[rp.id]) {
            if (selectableIds.includes(resourceId) && Object.prototype.hasOwnProperty.call(this.resourceSeats[rp.id], resourceId) && parseInt(this.resourceSeats[rp.id][resourceId])) {
              selectedReservationCount += this.resourceSeats[rp.id][resourceId];
              seats.push(resourceId + ':' + this.resourceSeats[rp.id][resourceId])
            }
          }
          data['pool_' + rp.id] = seats.join(',')
        }
        data.reservationCount = Math.max(selectedReservationCount, this.reservationCount)
      }
      if (this.hasResourcepoolHierarchy) {
        data['resourcepools'] = Object.keys(this.selectedResourcepools).map(k => this.selectedResourcepools[k]).filter(p => !!p).join(',')
      }
      if (this.participants.length && this.product.sharedPricetier && this.product.sharedPricetier.length) {
        for (i = 0; i < this.participants.length; i++) {
          data['pricetier_' + this.product.sharedPricetier[i].id] = this.participants[i]
        }
      } 

      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.posname($this.product))
        $this.$emit('success')
        $this.hideModal()
        $this.clear()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
        $this.hideModal()
      })
    },
    buyTicketClicked (show) {
      // if we don't have seat selection, add it to basket directly
      if (!parseInt(show.showseatmap)) {
        this.addShowToBasket(show)
      } else {
        // otherwise open seatmap
        this.openSeatMap(show, false, this.productShopId)
      }
    },
    addShowToBasket (show) {
      let $this = this
      let startDate = new Date(parseInt(show.start_ts, 10) * 1000)
      let endDate = new Date(parseInt(show.end_ts, 10) * 1000)
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        showId: show.id,
        shopId: this.productShopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: this.numberOfSeats[show.id] ? this.numberOfSeats[show.id] : this.reservationCount,
        reservationDateStart: this.getDMY(startDate),
        reservationTimeStart: this.getHM(startDate),
        reservationTimeEnd: this.getHM(endDate)
      }
      if (this.selectedSeats.length) {
        data.selectedSeats = this.selectedSeats.join(',')
        if (this.seatTicketId) {
          data.seatTicket = this.seatTicketId
        }
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.posname($this.product))
        $this.$emit('success')
        $this.hideModal()
        $this.clear()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
        $this.hideModal()
      })
    },
    addHourlyReservationToBasket () {
      let $this = this
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        shopId: this.productShopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: this.reservationCount,
        reservationDateStart: this.getDMY(this.startDate),
        reservationTimeStart: this.startTime,
        reservationTimeEnd: this.endTime
      }
      if (this.isTransportation) {
        data.origin = this.selectedOrigin.id
        data.destination = this.selectedDestination.id
        if (this.triptype === 'MP') {
          data.roundTrip = true
          data.returnDate = this.getDMY(this.returnDate)
          data.returnTime = this.returnTime
          data.returnEndTime = this.returnEndTime
        }
        if (parseInt(this.selectedOrigin.offset, 10) > parseInt(this.selectedDestination.offset, 10)) {
          data.linkType = 'P'
        }
      }
      if (this.isTicketActivity) {
        data.ticket = this.selectedTicket
        data.pricing = this.selectedTicketPricing
      }
      if (this.isResourceSelectionAllowed && this.hasSelectableResources) {
        let selectedReservationCount = 0
        for (i = 0; i < this.product.sharedResourcepool.length; i++) {
          let rp = this.product.sharedResourcepool[i]
          const selectableIds = this.getSelectableResources(rp).map(r => r.id)
          let seats = []
          for (let resourceId in this.resourceSeats[rp.id]) {
            if (selectableIds.includes(resourceId) && Object.prototype.hasOwnProperty.call(this.resourceSeats[rp.id], resourceId) && parseInt(this.resourceSeats[rp.id][resourceId])) {
              selectedReservationCount += this.resourceSeats[rp.id][resourceId];
              seats.push(resourceId + ':' + this.resourceSeats[rp.id][resourceId])
            }
          }
          data['pool_' + rp.id] = seats.join(',')
        }
        data.reservationCount = Math.max(selectedReservationCount, this.reservationCount)
      }
      if (this.hasResourcepoolHierarchy) {
        data['resourcepools'] = Object.keys(this.selectedResourcepools).map(k => this.selectedResourcepools[k]).filter(p => !!p).join(',')
      }
      if (this.participants.length && this.product.sharedPricetier && this.product.sharedPricetier.length) {
        for (var i = 0; i < this.participants.length; i++) {
          data['pricetier_' + this.product.sharedPricetier[i].id] = this.participants[i]
        }
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.posname($this.product))
        $this.$emit('success')
        $this.hideModal()
        $this.clear()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
        $this.hideModal()
      })
    },
    addProductToBasket () {
      let $this = this
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        shopId: this.productShopId,
        count: this.productCount
      }
      if (parseInt(this.product.voucher_open)) {
        data.voucherPrice = this.product.price
      }
      if (this.hasSelectableResources) {
        for (var poolId in this.selectedResources) {
          if (Object.prototype.hasOwnProperty.call(this.selectedResources, poolId)) {
            data['pool_' + poolId] = this.selectedResources[poolId]
          }
        }
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.posname($this.product))
        $this.$emit('success')
        $this.hideModal()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
    },
    async addNextTicketActivityToBasket (offset) {
      if (!offset) {
        offset = 0
      } else if (offset > 14) {
        return
      }
      let $this = this
      let mode = 'hours'
      let dateStr = DateTime.now({ zone: this.timezone }).toFormat('yyyy-MM-dd')
      let currD = DateTime.now({ zone: this.timezone }).toFormat('d')
      if (offset) {
        dateStr = DateTime.now({ zone: this.timezone }).plus({ days: offset }).toFormat('yyyy-MM-dd')
        currD = DateTime.now({ zone: this.timezone }).plus({ days: offset }).toFormat('d')
      }
      if (this.product.preselecteddates) {
        await this.updateAvailablePreselectedDates()
        if (this.availablePreselectedDates.length) {
          const ts = this.convertDateToTimestamp(this.availablePreselectedDates[0]) / 1000
          dateStr = DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat('yyyy-MM-dd')
          currD = DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat('d')
        } else {
          this.showPreviewModal()
          return
        }
      }
      let dateResponse = await axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.id + '/availabledates/' + dateStr + '.json?field=from&count=' + this.reservationCount + '&resource_count=' + this.resourceCount + '&mode=' + mode + '&apikey=' + this.apiKey)
      if (!dateResponse || !dateResponse.data || !dateResponse.data.length) {
        this.showAddedToBasketError()
        return
      }
      if (!this.product.preselecteddates) {
        for (let i = 0; i < dateResponse.data.length; i++) {
          let tuple = dateResponse.data[i]
          if (parseInt(tuple[0], 10) >= parseInt(currD, 10)) {
            currD = parseInt(tuple[0], 10)
            break
          }
        }
        if (currD < 10) {
          currD = '0' + currD
        }
        dateStr = DateTime.now({ zone: this.timezone }).toFormat('yyyy-MM') + '-' + currD
      }
      let timeResponse = await axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.id + '/availabletimes/' + dateStr + '.json?count=' + this.reservationCount + '&resource_count=' + this.resourceCount + this.clientStr + '&apikey=' + this.apiKey)
      if (!timeResponse || !timeResponse.data || !timeResponse.data.starttimes) {
        return
      }
      let startTime = false
      for (let i = 0; i < timeResponse.data.starttimes.length; i++) {
        if (DateTime.fromFormat(timeResponse.data.starttimes[i], 'H.mm', { zone: this.timezone }).toUnixInteger() >= DateTime.now({ zone: this.timezone }).toUnixInteger()) {
          startTime = timeResponse.data.starttimes[i]
          break
        }
      }
      if (!startTime) {
        return this.addNextTicketActivityToBasket(++offset)
      }
      let endTime = timeResponse.data.endtimes[startTime][0]
      let data = {
        version: this.version,
        locale: this.locale,
        product: this.product,
        shopId: this.productShopId,
        count: this.productCount,
        resourceCount: this.resourceCount,
        reservationCount: this.reservationCount,
        reservationDateStart: DateTime.fromFormat(dateStr, 'yyyy-MM-dd', { zone: this.timezone }).toFormat('d.M.yyyy'),
        reservationTimeStart: startTime,
        reservationTimeEnd: endTime
      }
      let priceResponse = await axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.id + '/fullprices.json?date=' + DateTime.fromFormat(dateStr, 'yyyy-MM-dd', { zone: this.timezone }).toUnixInteger() + '&starttime=' + startTime + '&endtime=' + endTime + '&mode=' + mode + '&resource_count=' + this.resourceCount + '&reservation_count=' + this.reservationCount + this.clientStr)
      let currentPricingIndex = this.getActivePricingIndex(priceResponse.data)

      if (!priceResponse || !priceResponse.data || !priceResponse.data.prices || !priceResponse.data.prices.detail || !priceResponse.data.prices.detail[currentPricingIndex] || !priceResponse.data.prices.detail[currentPricingIndex].tickets) {
        this.showAddedToBasketError()
        return
      }

      for (let j = 0; j < priceResponse.data.prices.detail[currentPricingIndex].tickets.length; j++) {
        let ticket = priceResponse.data.prices.detail[currentPricingIndex].tickets[j]
        if (parseInt(ticket.default)) {
          data.ticket = ticket.id
        }
      }
      if (!data.ticket) {
        this.showAddedToBasketError()
        return
      }
      data.pricing = priceResponse.data.prices.detail[currentPricingIndex].pricing
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.posname($this.product))
        $this.$emit('success')
        $this.hideModal()
        $this.clear()
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
        $this.hideModal()
      })
    },
    showGroupDealInfo () {
      this.groupDealInfoVisible = true
    },
    setHourlyPricing () {
      this.selectedPricing = 'hours'
      this.clear()
    },
    setDailyPricing () {
      this.selectedPricing = 'days'
      this.clear()
    },
    showDetailedPricing () {
      this.detailedPricingVisible = true
    },
    startDateChanged (d) {
      let $this = this
      this.minDate = d
      this.startDate = d
      if (this.hasMultipleDailyStartTimes) {
        this.getAvailableTimes(false, function () {
          if ($this.availabletimes && $this.availabletimes.starttimes && $this.availabletimes.starttimes.length) {
            $this.getFullPrices()
          } else {
            $this.fullprices = {}
          }
        })
      } else {
        this.getFullPrices()
      }
    },
    endDateChanged (d) {
      let $this = this
      this.maxDate = d
      this.endDate = d
      if (this.hasMultipleDailyStartTimes) {
        this.getAvailableTimes(false, function () {
          if ($this.availabletimes && $this.availabletimes.starttimes && $this.availabletimes.starttimes.length) {
            $this.getFullPrices()
          } else {
            $this.fullprices = {}
          }
        })
      } else {
        this.getFullPrices()
      }
    },
    hourlyDateChanged (d, setTime) {
      let $this = this
      this.minDate = d
      this.startDate = d
      this.getAvailableTimes(false, function () {
        if (setTime) {
          const startTime = DateTime.fromJSDate(d, { zone: $this.timezone }).toFormat($this._('H.mm'))
          if (startTime) {
            if ($this.availabletimes && $this.availabletimes.starttimes) {
              if($this.availabletimes.starttimes.includes(startTime)) {
                $this.startTime = startTime
              } else {
                $this.startTime = $this.availabletimes.starttimes[0]
              }
            }
            const endTime = $this.defaultEndTime(d)
            if (endTime && $this.availabletimes && $this.availabletimes.endtimes && ($this.availabletimes.endtimes[$this.startTime] || []).includes(endTime)) {
              $this.endTime = endTime
            }
            $this.startTimeChanged()
          }
        }
        $this.getFullPrices()
      })
    },
    // Start times use the same "H.mm" form as availabletimes.json
    defaultStartTime () {
      if (!this.defaultStartDate) {
        return null
      }
      return DateTime.fromJSDate(this.defaultStartDate, { zone: this.timezone }).toFormat('H.mm')
    },
    // End times are "H.mm", "24.00" for midnight or "H.mm+N" when they fall N days after the start
    defaultEndTime (start) {
      if (!this.defaultEndDate || !start || this.defaultEndDate <= start) {
        return null
      }
      const s = DateTime.fromJSDate(start, { zone: this.timezone }).startOf('day')
      const e = DateTime.fromJSDate(this.defaultEndDate, { zone: this.timezone })
      const days = Math.round(e.startOf('day').diff(s, 'days').days)
      const time = e.toFormat('H.mm')
      if (days === 1 && time === '0.00') {
        return '24.00'
      }
      return days > 0 ? time + '+' + days : time
    },
    returnDateChanged (d) {
      let $this = this
      this.returnDate = d
      this.getFullPrices()
      this.getAvailableTimes('P', function () {
        $this.getFullPrices()
      })
    },
    preselectedDateChanged (d) {
      this.minDate = d
      this.startDate = d
      let ed = new Date(d.getTime())
      let days = 1
      let unitArr = this.product.product_units.split(';')
      for (var i = 0; i < unitArr.length; i++) {
        if (unitArr[i].match(/d$/)) {
          days = parseInt(unitArr[i], 10)
          break
        }
      }
      ed.setDate(ed.getDate() + days)
      this.maxDate = ed
      this.endDate = ed
      this.getFullPrices()
    },
    quantityChanged () {
      this.updateParticipantCount(!this.hasParticipantPricing)
      this.getFullPrices()
      if (this.currentDate) {
        this.hourlyDateChanged(this.currentDate, this.mode !== 'daily')
      }
      //this.getAvailableTimes()
    },
    participantsChanged () {
      this.updateResourceCount()
      this.getFullPrices()
      if (this.currentDate) {
        this.hourlyDateChanged(this.currentDate, this.mode !== 'daily')
      }
    },
    updateParticipantCount (force) {
      if (typeof force !== 'undefined' && force) {
        this.participants[0] = 0
      }
      if (this.resourceCount > this.reservationCount) {
        let missing = this.resourceCount - this.reservationCount
        this.participants[0] = Number(this.participants[0]) + missing
      }
    },
    updateResourceCount () {
      if (this.reservationCount < this.resourceCount) {
        this.resourceCount = Math.max(1, this.reservationCount)
      } else {
        let minResourceCount = this.getMinResourceCount(this.reservationCount)
        if (this.resourceCount < minResourceCount) {
          this.resourceCount = minResourceCount
        }
      }
    },
    getMinResourceCount (reservationCount) {
      let minResourceCount = 0
      for (var i = 0; i < this.product.sharedResourcepool.length; i++) {
        if (!parseInt(this.product.sharedResourcepool[i].selectable)) {
          continue
        }
        let counts = []
        for (var j = 0; j < this.product.sharedResourcepool[i].sharedResource.length; j++) {
          counts.push(parseInt(this.product.sharedResourcepool[i].sharedResource[j].count, 10))
        }
        counts = counts.sort((a, b) => b - a)
        let stillRequired = reservationCount
        for (j = 0; j < counts.length; j++) {
          stillRequired -= counts[j]
          minResourceCount++
          if (stillRequired <= 0) {
            break
          }
        }
      }
      return Math.max(1, minResourceCount)
    },
    originSelected () {
      let $this = this
      this.selectedRoute = this.selectedOrigin.route
      if (this.selectedDestination) {
        this.getAvailableTimes(false, function () {
          $this.getFullPrices()
        })
        this.getAvailableTimes('P')
      }
      this.initParticipants()
    },
    destinationSelected () {
      let $this = this
      if (this.selectedOrigin) {
        this.getFullPrices()
        this.getAvailableTimes(false, function () {
          $this.getFullPrices()
        })
        this.getAvailableTimes('P')
      }
      this.initParticipants()
    },
    initParticipants () {
      // Initialize price tier default values
      // If the price tier has a default value, use it
      // Otherwise use the old default system, which is minParticipants for the first tier and 0 for the rest
      this.defaultParticipants = []
      for (let i = 0; i < this.product.sharedPricetier.length; i++) {
        this.defaultParticipants.push(this.product.sharedPricetier[i].default_count ? parseInt(this.product.sharedPricetier[i].default_count, 10) : (i > 0 ? 0 : this.defaultParticipantCount))
      }
      /*
      if (!this.defaultParticipants.length) {
        this.defaultParticipants = [this.minParticipants]
        for (var i = 1; i < this.product.sharedPricetier.length; i++) {
          this.defaultParticipants.push(0)
        }
      }
      */
    },
    startTimeChanged () {
      if (this.endTime && this.availabletimes && this.availabletimes.endtimes && this.availabletimes.endtimes[this.startTime] && this.availabletimes.endtimes[this.startTime].indexOf(this.endTime) === -1) {
        this.endTime = this.availabletimes.endtimes[this.startTime][0]
      }
      this.getFullPrices()
    },
    endTimeChanged () {
      this.getFullPrices()
    },
    returnTimeChanged () {
      if (this.endTime && this.availabletimes && this.availabletimes.endtimes && this.availabletimes.endtimes[this.startTime] && this.availabletimes.endtimes[this.startTime].indexOf(this.endTime) === -1) {
        this.endTime = this.availabletimes.endtimes[this.startTime][0]
      }
      this.getFullPrices()
    },
    enableGroupDealDateSelector () {
      this.showGroupDealDateSelector = true
      this.groupDealDateSelected = false
    },
    openGroupDealDays () {
      let $this = this
      axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/groupdeals/${this.product.id}/reservations/public.json`)
      .then(function (response) {
        $this.groupDealDays = response.data
        $this.showGroupDealDays = true
      })
      .catch(function () {
        $this.closeGroupDealDays()
      })
    },
    closeGroupDealDays () {
      this.groupDealDays = []
      this.showGroupDealDays = false
    },
    selectGroupDealDate (d) {
      let startDate = new Date(d.start_ts * 1000)
      let endDate = new Date(d.end_ts * 1000)
      this.startDate = startDate
      this.endDate = endDate
      this.groupDealDateSelected = true
      this.showGroupDealDateSelector = false
    },
    hasTickets(show) {
      return parseInt(show.upcoming, 10) !== 1 && show.pricing.sharedProduct.length > 0
    },
    hasSeatMap(show) {
      return !!parseInt(show.showseatmap, 10)
    },
    canBuy(show) {
      return parseInt(show.upcoming, 10) !== 1 && this.hasTickets(show) && parseInt(this.product.hide_pricing) !== 2
    },
    getShowReservations (show) {
      return parseInt(show.resource_reservations, 10)
    },
    getShowCapacity (show) {
      return parseInt(show.resource_capacity, 10)
    },
    getShowRemainingSeats (show) {
      if(parseInt(this.getShowCapacity(show) - this.getShowReservations(show), 10) < 1 || isNaN(parseInt(this.getShowCapacity(show) - this.getShowReservations(show), 10))) return 0
      return this.getShowCapacity(show) - this.getShowReservations(show)
    },
    toShowTime (show) {
      if (parseInt(show.upcoming, 10) !== 1) {
        if (show.startdate !== show.enddate) {
          return this._('at') + ' ' + DateTime.fromSeconds(Number(show.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) + ' - ' + DateTime.fromSeconds(Number(show.end_ts), { zone: this.timezone }).toFormat('ddd') + ' ' + DateTime.fromSeconds(Number(show.end_ts), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' + DateTime.fromSeconds(Number(show.end_ts), { zone: this.timezone }).toFormat(this.timeFormat)
        }
        return this._('at') + ' ' + DateTime.fromSeconds(Number(show.start_ts), { zone: this.timezone }).toFormat(this.timeFormat)
      }
      return ''
    },
    toISOTime (show) {
      if (parseInt(show.upcoming, 10) !== 1) {
        return DateTime.fromJSDate(new Date(parseInt(show.start_date, 10) * 1000), { zone: this.timezone }).toISO()
      } else {
        return ''
      }
    },
    getDMY (d) {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear()
    },
    getYMD (d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
    },
    getHM (d) {
      return d.getHours() + '.' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
    },
    async getFullPrices () {
      if (!this.datesSelected) {
        return
      }
      let dateStr = ''
      dateStr += 'date=' + Math.round(this.startDate.getTime() / 1000)
      if (this.endDate) {
        dateStr += '&enddate=' + Math.round(this.endDate.getTime() / 1000)
      }
      if (this.startTime && this.endTime) {
        dateStr += '&starttime=' + this.startTime + '&endtime=' + this.endTime
      }
      let countStr = ''
      countStr += '&resource_count=' + this.resourceCount
      countStr += '&reservation_count=' + this.reservationCount
      if (this.selectedRateplan) {
        countStr += '&rateplan=' + this.selectedRateplan
      }
      if (this.participants.length && this.product.sharedPricetier && this.product.sharedPricetier.length) {
        for (var i = 0; i < this.participants.length; i++) {
          countStr += '&pricetier_' + this.product.sharedPricetier[i].id + '=' + this.participants[i]
        }
      }
      let originStr = ''
      let destStr = ''
      if (this.selectedOrigin && this.selectedDestination) {
        if (this.selectedOrigin) {
          originStr = '&origin=' + this.selectedOrigin.id
        }
        if (this.selectedDestination) {
          destStr = '&destination=' + this.selectedDestination.id
        }
        if (this.isReturnTrip) {
          destStr += '&roundtrip=1'
        }
      }
      let resourceStr = '&resources=true'
      let resourcepoolStr = this.hasResourcepoolHierarchy ? '&resourcepools=true' : ''
      let prices = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/products/${this.product.id}/fullprices.json?${dateStr}&mode=${this.selectedPricing}${countStr}${originStr}${destStr}${resourceStr}${resourcepoolStr}${this.clientStr}`)
      this.fullprices = prices.data
      if (this.isTicketActivity && this.fullprices.prices && this.fullprices.prices.detail && this.fullprices.prices.detail[this.activePricingIndex] && this.fullprices.prices.detail[this.activePricingIndex].tickets) {
        for (i = 0; i < this.fullprices.prices.detail[this.activePricingIndex].tickets.length; i++) {
          let ticket = this.fullprices.prices.detail[this.activePricingIndex].tickets[i]
          if (parseInt(ticket.default)) {
            this.selectedTicket = ticket.id
            break
          }
        }
      }
      if (this.hasResourcepoolHierarchy) {
        this.resourcepoolAvailability = (this.fullprices.selectableResourcepools ? this.fullprices.selectableResourcepools : [])
      }
    },
    async getAvailableTimes (linkType, callback) {
      if (!this.startDate) {
        return
      }
      let dateStr = ''
      if (!linkType || linkType === 'M') {
        dateStr = this.getYMD(this.startDate)
      } else {
        dateStr = this.getYMD(this.returnDate)
      }
      let originStr = ''
      let destStr = ''
      let linkStr = ''
      if (!linkType || linkType === 'M') {
        if (this.selectedOrigin) {
          originStr = '&origin=' + this.selectedOrigin.id
        }
        if (this.selectedDestination) {
          destStr = '&destination=' + this.selectedDestination.id
        }
      } else {
        if (this.selectedOrigin) {
          originStr = '&origin=' + this.selectedDestination.id
        }
        if (this.selectedDestination) {
          destStr = '&destination=' + this.selectedOrigin.id
        }
      }
      if (linkType || (this.selectedOrigin && this.selectedDestination && parseInt(this.selectedOrigin.offset, 10) > parseInt(this.selectedDestination.offset, 10))) {
        if (parseInt(this.selectedOrigin.offset, 10) < parseInt(this.selectedDestination.offset, 10)) {
          linkStr = '&linktype=' + linkType
        } else {
          if (!linkType || linkType === 'M') {
            linkStr = '&linktype=P'
          } else {
            linkStr = '&linktype=M'
          }
        }
      }
      let endStr = ''
      if (this.endDate && this.getYMD(this.endDate) !== this.getYMD(this.startDate)) {
        endStr = ':' + this.getYMD(this.endDate)
      }
      let times = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/products/${this.product.id}/availabletimes/${dateStr}${endStr}.json?count=${this.reservationCount}${this.clientStr}${originStr}${destStr}${linkStr}&apikey=${this.apiKey}`)
      if (!linkType || linkType === 'M') {
        this.availabletimes = times.data
        if (this.availabletimes && this.availabletimes.starttimes) {
          this.startTime = this.availabletimes.starttimes[0]
        }
        if (this.availabletimes && this.availabletimes.endtimes && this.availabletimes.endtimes[this.startTime]) {
          this.endTime = this.availabletimes.endtimes[this.startTime][0]
        }
      } else {
        this.availablereturntimes = times.data
        if (this.availablereturntimes && this.availablereturntimes.starttimes) {
          this.returnTime = this.availablereturntimes.starttimes[0]
        }
        if (this.availablereturntimes && this.availablereturntimes.endtimes && this.availablereturntimes.endtimes[this.returnTime]) {
          this.returnEndTime = this.availablereturntimes.endtimes[this.returnTime][0]
        }
      }
      if (callback) {
        callback()
      }
    },
    getNextShows () {
      return new Promise(async (resolve, reject) => {
        let $this = this
        if (this.shows.length || this.gettingShows) {
          resolve()
          return false
        }
        this.gettingShows = true
        if (parseInt(this.product.subtype, 10) === this.SUBTYPE_EVENT) {
          const twoWeeksAgo = Math.floor(new Date(Date.now() - 14 * 24 * 3600 * 1000).getTime() / 1000)
          let availabilityResponse = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/products/${this.product.id}/availablepreselecteddates.json?start_ts=${twoWeeksAgo}`)
          let showResponse = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/products/${this.product.id}/shows.json?details=true&start_ts=${twoWeeksAgo}&apikey=${this.apiKey}`)
          this.showAvailability = availabilityResponse.data
          this.shows = showResponse.data
          this.shows.forEach(function (show) {
            // this.weekdayname = dayNamesMin[parseInt(this.weekday,10)]
            $this.numberOfSeats[show.id] = 0
          })
        }
        this.gettingShows = false
        resolve()
      })
    },
    async updateShowCapacities () {
      let $this = this
      if (parseInt(this.product.subtype, 10) === this.SUBTYPE_EVENT) {
        let showResponse = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/products/${this.product.id}/shows.json?details=true&storefront=true&apikey=${this.apiKey}`)
        let showDatas = showResponse.data
        showDatas.forEach(function (showItem) {
          // this.weekdayname = dayNamesMin[parseInt(this.weekday,10)]
          $this.shows.some(function (show) {
            $this.numberOfSeats[show.id] = 0
            if (show.id === showItem.id) {
              show.resource_reservations = parseInt(showItem.resource_reservations, 10);
              show.resource_capacity = parseInt(showItem.resource_capacity, 10);
              return true
            }
          })
        })
      }
    },
    async loadShowCapacity (show) {
      let showResponse = await axios.get(`${this.baseDomain}${this.productShopId}/${this.locale}/shows/${show.id}.json?details=true&storefront=true`)
      let showData = showResponse.data
      show.resource_reservations = parseInt(showData.resource_reservations, 10);
      show.resource_capacity = parseInt(showData.resource_capacity, 10);
      this.numberOfSeats[show.id] = 0
    },
    isShowAvailable (show) {
      if (!this.showAvailability.length) {
        return false
      }
      let d = this.getDMY(new Date(parseInt(show.start_ts, 10) * 1000))
      for (var i = 0; i < this.showAvailability.length; i++) {
        let ad = this.showAvailability[i]
        if (ad === d) {
          return true
        }
      }
      return false
    },
    getUnitStr (unitType) {
      switch (parseInt(unitType)) {
        case this.UNIT_MINUTE:
          return this._('min')
        case this.UNIT_HOUR:
          return this._('h')
        case this.UNIT_DAY:
          return this._('d')
      }
      return ''
    },
    convertToHoursAndMinutes (s) {
      let re = new RegExp(' ' + this._('min') + '$')
      if (!s.match(re)) {
        return s
      }
      let minuteArr = s.match(/^[0-9]+/)
      let minutes = minuteArr[0]
      let hours = Math.floor(minutes / 60)
      let remainder = minutes % 60
      return (hours > 0 ? hours + ' ' + this._('h') : '') + (hours > 0 && remainder > 0 ? ' ' : '') + (remainder > 0 ? remainder + ' ' + this._('min') : '')
    },
    getPricetierPrice (pricetier) {
      var i = 0
      if (!this.hasMultiplePrices) {
        if (!this.product.ownPricerow || !this.product.ownPricerow[0]) {
          return ''
        }
        let tiers = this.product.ownPricerow[0].pricetiers.split(';')
        for (i = 0; i < tiers.length; i++) {
          let tierPrice = tiers[i].split(':')
          if (parseInt(tierPrice[0], 10) === parseInt(pricetier.id, 10)) {
            return tierPrice[1]
          }
        }
        return ''
      } else {
        if (!this.fullprices.prices) {
          return ''
        }
        let data = this.fullprices
        for (i = 0; i < data.prices.pricetiers.length; i++) {
          if (parseInt(data.prices.pricetiers[i].id, 10) === parseInt(pricetier.id, 10)) {
            return data.prices.pricetiers[i].price
          }
        }
        return ''
      }
    },
    displayDetailDates (index) {
      if (index > 0) {
        return this.fullprices.prices.detail[index].start !== this.fullprices.prices.detail[index - 1].start
      }
      return true
    },
    getGroupDealDisclaimer () {
      return ''
    },
    convertDateToTimestamp (dateStr) {
      if (!dateStr) {
        return 0
      }
      let d = 0
      let m = 0
      let y = 0
      if (dateStr.match(/\./)) { // Assuming d.m.y
        let dateArr = String(dateStr).split('.')
        d = dateArr[0]
        m = dateArr[1]
        y = dateArr[2]
      } else { // Assuming m/d/y or y/m/d
        let dateArr = String(dateStr).split('/')
        if (dateArr[0].length > 2) { // y/m/d
          d = dateArr[2]
          m = dateArr[1]
          y = dateArr[0]
        } else { // m/d/y
          d = dateArr[1]
          m = dateArr[0]
          y = dateArr[2]
        }
      }
      return new Date(new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)).getTime()).getTime()
    },
    convertToMinutes (time) {
      let extraDays = 0
      if (time.match(/\+/)) {
        let extraArr = String(time).split('+')
        time = extraArr[0]
        extraDays = parseInt(extraArr[1], 10)
      }
      let timeArr = String(time).split('.')
      let h = parseInt(timeArr[0], 10)
      let m = parseInt(timeArr[1], 10)
      h += extraDays * 24
      return h * 60 + m
    },
    convertToTime (minutes) {
      let minStr = (minutes % 60)
      if (minStr < 10) {
        minStr = '0' + minStr
      }
      return Math.floor(minutes / 60) + '.' + minStr
    },
    preselectedValueClass(val) {
      if(val === this.customPrice) {
        return 'btn btn-primary'
      }
      return 'btn btn-default'
    },
    preselectedValueClicked(val) {
      this.customPrice = val
    },
    preselectedClass (date) {
      if (this.availablePreselectedDates.indexOf(date) === -1) {
        let key = this.reservationCount + '-' + this.resourceCount + '-' + this.selectedPricing
        if (this.availablePreselectedDatesLoading && this.availablePreselectedDatesLoading[key]) {
          return 'btn disabled'
        }
        return 'btn btn-danger'
      }
      if (this.startDate && this.startDate.getTime() === new Date(this.convertDateToTimestamp(date)).getTime()) {
        return 'btn btn-success'
      }
      return 'btn btn-default'
    },
    getParticipantRangeString (detail) {
      let s = ''
      let minp = parseInt(detail.minparticipants, 10)
      let maxp = parseInt(detail.maxparticipants, 10)
      if (!minp) {
        minp = 1
      }
      s += minp
      if (maxp) {
        if (maxp !== minp) {
          s += ' - ' + maxp
        }
      } else {
        s += '+'
      }
      s += ' ' + this._('pers') + ':'
      return s
    },
    async loadOrderSummary () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.productShopId + '/products/' + this.product.id + '/orders.json?items=true&start=' + this.summaryStart + '&end=' + this.summaryEnd + '&apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.orders = response.data
    },
    getSelectableResources(resourcePool) {
      if (!this.fullprices || !this.fullprices.selectableResources) {
        return resourcePool.sharedResource
      }
      return resourcePool.sharedResource.filter(r => this.fullprices.selectableResources.includes(parseInt(r.id, 10)))
    },
    updateStartTimeAvailability() {
      return new Promise(async (resolve, reject) => {
        this.hasStartTimesToday = false
        let dateStr = this.getYMD(new Date())
        let timeResponse = await axios.get(this.baseDomain + this.productShopId + '/' + this.locale + '/products/' + this.product.id + '/availabletimes/' + dateStr + '.json?count=' + this.reservationCount + '&resource_count=' + this.resourceCount + this.clientStr + '&apikey=' + this.apiKey)
        if (!timeResponse || !timeResponse.data || !timeResponse.data.starttimes) {
          resolve()
          return
        }
        for (let i = 0; i < timeResponse.data.starttimes.length; i++) {
          if (DateTime.fromFormat(timeResponse.data.starttimes[i], 'H.mm', { zone: this.timezone }).toUnixInteger() >= DateTime.now({ zone: this.timezone }).toUnixInteger()) {
            this.hasStartTimesToday = true
            resolve()
            break
          }
        }
        resolve()
      })
    }
  }
}

</script>

<style scoped>
.product-order-resourceswrap {
  clear: both;
}
.product-order-resourceswrap .list-group-item {
  height: 70px;
}
.product-header {
  background-color: #679f38; 
  color: #fff;
}
.summary-wrap {
  min-height: 300px;
}
</style>